<template>
  <v-container class="container-card">
    <v-card>
      <Parametros />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Parametros from "@/components/comissao/funcoesParametros/departamentos/Departamento";
export default {
  components: {
    Parametros
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Funções Parâmetros Departamento");
  }
};
</script>

<style></style>
